import type { WorkspaceDefaultProjectType } from "schemas/generated/workspaceDefaultProjectType";

import { workspaceDefaultProjectTypeSchema } from "schemas/workspaceDefaultProjectType";

// NOTE (Max, 2026-09-16): A funnel picked with the signup screen's switch is
// persisted so a returning visitor lands back on it.
export const signupDefaultProjectTypeStorageKey =
  "replo.signup.defaultProjectType";

// Shopify App Store installs must stay on the Shopify funnel: the backend
// classifies these signups as source=shopify and would discard an "agent"
// funnel choice anyway, so offering the switch would be a bait-and-switch.
const shopifyInstallIntentParams = [
  "nonce",
  "shopify_shop_url",
  "shopifyIntegrationId",
  "pendingAppInstallationId",
];

export function hasShopifyInstallIntent(
  searchParams: URLSearchParams,
): boolean {
  return shopifyInstallIntentParams.some((param) => {
    return Boolean(searchParams.get(param));
  });
}

// Sent campaign emails tuck ?source=<code> inside a `next` back to /beta/enable, so read that first.
export function getCampaignSourceFromParams(
  searchParams: URLSearchParams,
): string | null {
  const next = searchParams.get("next");
  const queryStart = next?.indexOf("?") ?? -1;
  const sourceFromNext =
    next && queryStart !== -1
      ? new URLSearchParams(next.slice(queryStart + 1)).get("source")
      : null;
  // `||` on purpose: an empty source= is treated as absent, not logged as "".
  return sourceFromNext || searchParams.get("source") || null;
}

export function persistSignupProjectType(
  projectType: WorkspaceDefaultProjectType,
) {
  localStorage.setItem(signupDefaultProjectTypeStorageKey, projectType);
}

export function getPersistedSignupProjectType(): WorkspaceDefaultProjectType | null {
  const parsed = workspaceDefaultProjectTypeSchema.safeParse(
    localStorage.getItem(signupDefaultProjectTypeStorageKey),
  );
  return parsed.success ? parsed.data : null;
}

export function resolveSignupDefaultProjectType({
  userSelected,
  persisted,
}: {
  userSelected: WorkspaceDefaultProjectType | null;
  persisted: WorkspaceDefaultProjectType | null;
}): WorkspaceDefaultProjectType {
  return userSelected ?? persisted ?? "agent";
}
